export const environment = {
  production: false,
  analytics: false,
  apiBaseUrl: 'https://dev.zenar.kz/api',
};
